import { ComponentPropsWithoutRef, useMemo } from 'react';
import { Button } from '@givebutter/primitives/button';
import * as Dialog from 'components/dialog';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { isoDateFromServer } from 'helpers/dates';
import GivebutterPlusLogo from 'images/givebutter-plus-logo.svg';
import MrButterJumping from 'images/mr-butter-jumping.png';

interface TrialRegistrationCompleteProps extends ComponentPropsWithoutRef<'div'> {}
const TrialRegistrationComplete = (props: TrialRegistrationCompleteProps) => {
    const { trialEndsAt } = useCurrentAccount();

    const endDateMsg = useMemo(() => {
        if (!trialEndsAt) {
            return null;
        }
        const endsAt = isoDateFromServer(trialEndsAt).toFormat('LLLL dd');
        return `Your account is on a free trial until ${endsAt}`;
    }, [trialEndsAt]);

    return (
        <div className="flex flex-col gap-6" {...props}>
            <div className="flex flex-col gap-6">
                <div className="flex flex-col items-center justify-center gap-3">
                    <img
                        src={MrButterJumping}
                        className="max-w-28"
                        alt="Mr. Butter jumping for joy"
                    />
                    <img
                        className={'w-full max-w-44'}
                        src={GivebutterPlusLogo}
                        alt="Givebutter Plus logo"
                    />
                    <div className="text-center text-3xl">{endDateMsg}</div>
                    <div className="text-center text-gray-600">
                        Upgrade your account at any time during the trial. If you choose not to
                        upgrade, your account will lose access to all Givebutter Plus features.
                    </div>
                </div>

                <Dialog.Cancel asChild>
                    <Button variant="solid" className="w-full">
                        Let's go!
                    </Button>
                </Dialog.Cancel>
            </div>
        </div>
    );
};

export { TrialRegistrationComplete };
